<template>
  <div class="modal fade" id="identifyModal" tabindex="-1" role="dialog" aria-labelledby="identifyModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-identify" :class="{'modal-dialog-identify-alert': alertPage}" role="document">
      <div class="arrow-up"></div>
      <div class="modal-content modal-content-identify" :class="{'modal-content-identify-small': !(users.length > 0)}">
        <div class="modal-header modal-header-identify">
          <label class="">Search for users:</label><br>
          <input type="text" class="" v-model="term" @keyup="search()">
        </div>
        <div class="modal-body modal-body-identify" v-if="users.length > 0">
          <div class="container-fluid identify-modal-container right-container" style="overflow-y: scroll !important;" data-simplebar id="items-container">
            <table class="table items-table">
              <tbody>
                <tr class="item" v-for="(user, index) in users" :key="index" @click="select(user.id)" data-dismiss="modal">
                  <td class="identify-avatar">
                    <user-photo :user="user" />
                  </td>
                  <td>
                    <p>{{ user.first_name }} {{ user.last_name }} [{{user.id}}]</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer modal-footer-identify">
          <button type="button" class="btn btn-primary my-btn btn-identify" @click.prevent="select(0)" data-dismiss="modal">
            Set As Unknown
          </button>
          <a class="btn btn-primary my-btn btn-identify" data-dismiss="modal" href="#" @click.prevent="create(item.user)" v-if="item.user_id">
            Create New User
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UserPhoto from '@/components/users/Photo';

  export default {
    name: 'IdentifyModal',
    components: {
      UserPhoto
    },
    props: {
      item: {
        required: true,
        type: Object,
      },
      alertPage: 0,
    },
    data() {
      return {
        term: '',
        users: []
      };
    },
    methods:{
      getRequestData(id) {
        let data = new FormData();

        data.set('event_id', this.item.id);
        data.set('user_id', id);

        return data;
      },
      resetModal() {
        this.term = '';
        this.users = [];
      },
      search() {
        if (this.term.length < 1) {
          this.users = [];
          return;
        }

        this.axios.get(`/users?query=${this.term}`)
          .then(response => {
            if (this.term) {
              this.users = response.data.users;
            }
          })
          .catch(() => this.$emit('identified', {status: 'error', message: 'An error occured.'}));
      },
      select(user) {
        this.updateEvent(this.getRequestData(user));
      },
      updateEvent(data, newUser = false) {
        this.axios.post(`/identify`, data)
          .then((response) => {
            this.$emit('identified', {
              status: 'success',
              message: 'Identification successfully done.',
              event: response.data,
              new: newUser
            });
            this.resetModal();
          })
          .catch(() => this.$emit('identified', {status: 'error', message: 'An error occured.'}));
      },
      create(user) {
        if (user.type != 7) {
          this.updateEvent(this.getRequestData(0), true);

          return;
        }

        this.$emit('create', user);
      }
    }
  };
</script>
